import{sendToCH2 as e}from"./metrics.sender.es.js";const r=r=>{e(r)};export{r as sendGlobalSearchMetrics};
